import { Breadcrumb, Flex, Heading } from '@applyboard/crystal-ui';
import { BreadcrumbItem } from '~/utils';
import { useGradeConversionDetails } from '../context/GradeConversionDetailsContext';

export function GradeConversionDetailsHeading() {
  const { conversionTable, isLoadingConversionTable } = useGradeConversionDetails();

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      href: '/conversion-rules/grade-conversions',
      label: 'Grade Conversions',
    },
    {
      href: `/conversion-rules/grade-conversions/${conversionTable?.id}`,
      label: `Grade Conversion Details`,
    },
  ] as BreadcrumbItem[];

  return (
    <Flex direction="column" gap={8}>
      {!isLoadingConversionTable && <Breadcrumb items={breadcrumbItems} />}
      <Flex justify="between" align="center">
        <Heading contrast="high" level={1} variant="titleL">
          {conversionTable?.name}
        </Heading>
      </Flex>
    </Flex>
  );
}
